module.exports = {
    production: 'production',
    preprod: 'preprod',
    stage: 'stage',
    test: 'test',
    dev1: 'dev1',
    development: 'development',
};
